import React, {useCallback, useEffect} from 'react';

import Html from 'helpers/Html';
import useSession from 'hooks/useSession';

const classSVG = 'wrapper-ruler';
const classLine = 'ruler';
const classText = 'text';
let ruleMove = false;
let position = {
	x1: 0,
	y1: 0,
	x2: 0,
	y2: 0
};

function Rule(props) {
	let {
		active = false,
		disabled = false,
		wrapper,
		currentZoom
	} = props;


	const {
		getCmValue
	} = useSession();

	const updateRender = useCallback(() => {
		let elementHTML = wrapper.current;
		let line = elementHTML.querySelector('.' + classLine);
		if (line !== null) {
			line.setAttribute('x1', position.x1);
			line.setAttribute('y1', position.y1);
			line.setAttribute('x2', position.x2);
			line.setAttribute('y2', position.y2);
		}

		let text = elementHTML.querySelector('.' + classText);

		if (text !== null) {
			let a = position.x2 - position.x1;
			if (position.x1 > position.x2) {
				a = position.x1 - position.x2;
			}
			let b = position.y1 - position.y2;
			if (position.y2 > position.y1) {
				b = position.y2 - position.y1;
			}

			let c = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2));
			let cScaled = c / currentZoom;
			let sizeCm = parseFloat(getCmValue(cScaled));
			sizeCm = Math.round(sizeCm * 100) / 100;
			if (sizeCm !== 0) {
				text.setAttribute('x', position.x2 + 20);
				text.setAttribute('y', position.y2 + 5);
				text.innerHTML = sizeCm + 'cm';
			} else {
				text.innerHTML = '';
			}
		}
	}, [currentZoom]);

	const updatePosition = useCallback((index, event) => {
		position['x' + index] = event.offsetX;
		position['y' + index] = event.offsetY;
		updateRender();
	}, [updateRender]);

	const onMove = (evt) => {
		if (ruleMove) {
			updatePosition(2, evt);
		}
	}

	const onUp = () => {
		ruleMove = false;
		position = {
			x1: 0,
			y1: 0,
			x2: 0,
			y2: 0
		}
		updateRender();
	}

	const onDown = (evt) => {
		ruleMove = true;
		updatePosition(1, evt);
		updatePosition(2, evt);
	}

	useEffect(() => {
		let elementHTML = wrapper.current;
		let svg = elementHTML.querySelector('.' + classSVG);
		if (elementHTML !== null) {
			if (active) {
				if (elementHTML !== null && svg === null) {
					let size = Html.getElementSize(elementHTML);
					let svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
					svg.setAttribute('class', classSVG);
					svg.setAttribute('style', 'width:' + size.width + 'px;height:' + size.height + 'px;');
					elementHTML.append(svg);

					let newLine = document.createElementNS('http://www.w3.org/2000/svg', 'line');
					newLine.setAttribute('class', classLine);
					svg.append(newLine);


					let text = document.createElementNS('http://www.w3.org/2000/svg', 'text');
					text.setAttribute('class', classText);
					svg.append(text);

				}
			} else {
				if (svg !== null) {
					svg.remove();
				}
			}
		}

	}, [active])

	useEffect(() => {
		const element = wrapper.current
		element.addEventListener('mousemove', onMove, false);
		element.addEventListener('mouseup', onUp, false);
		element.addEventListener('mousedown', onDown, false);

		return () => {
			element.removeEventListener('mousemove', onMove);
			element.removeEventListener('mouseup', onUp);
			element.removeEventListener('mousedown', onDown);
		}
	}, [wrapper, updateRender]);

	return (
		<button
			type="button"
			className={'btntool btn btn-primary p-0' + (active ? ' active' : '') + (disabled ? ' disabled' : '')}
			onClick={() => {
				props.setActive(2);
			}}
		>
			<svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" fill="none"
			     strokeLinecap="round" strokeLinejoin="round">
				<line x1="17" y1="10" x2="3" y2="10"></line>
				<line x1="21" y1="6" x2="3" y2="6"></line>
				<line x1="21" y1="14" x2="3" y2="14"></line>
				<line x1="17" y1="18" x2="3" y2="18"></line>
			</svg>
		</button>
	);
}

export default Rule;
